// extracted by mini-css-extract-plugin
module.exports = {"banner":"_d020571","content":"_3e0f2c5","text":"_41a5194","button":"_ac6dfbb"};